import type { SVGProps } from 'react'

interface SvgPipeProps extends SVGProps<SVGSVGElement> {
  strokeWidth?: string
}

const SvgPipe: React.FC<SvgPipeProps> = ({ strokeWidth = '1', ...props }) => (
  <svg
    width="1"
    height="29"
    viewBox="0 0 1 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line
      x1="0.5"
      y1="-2.18557e-08"
      x2="0.500001"
      y2="29"
      stroke="#ACACAC"
      strokeWidth={strokeWidth}
    />
  </svg>
)

export default SvgPipe
